import React, {

    useState

} from "react";

import "./RecentAssessmentCard.css";

import {

    ArrowRight,

    Activity,

    X

} from "lucide-react";

const RecentAssessmentCard = ({

    data

}) => {

    const history =

        data?.history || [];

    const latestAssessments =

        history.slice(0, 4);

    const [showPopup,

        setShowPopup] =

        useState(false);

    const formatDate = (

        date

    ) => {

        if (!date)

            return "-";

        return new Date(

            date

        ).toLocaleDateString(

            "en-IN",

            {

                day: "2-digit",

                month: "short",

                year: "numeric"

            }

        );

    };

    const groupedTests = [

        "Visual Acuity",

        "Contrast Sensitivity",

        "Reaction Speed",

        "Complex Reaction",

        "Search Span",

        "Working Memory",

        "Short Term Memory",

        "Color Vision",

        "Anticipation"

    ].map(test => {

        const latest =

            history.find(

                item =>

                    item.testName === test

            );

        return {

            testName: test,

            date:

                latest?.date ||

                null,

            score:

                latest?.score ||

                "-"

        };

    });
    return (

    <>

        <div className="recent-assessment-card">

            <div className="recent-header">

                <div>

                    <h3>

                        Recent Assessments

                    </h3>

                    <p>

                        Your latest completed assessments.

                    </p>

                </div>

                <div className="recent-icon">

                    <Activity size={24} />

                </div>

            </div>

            <div className="assessment-list">

                {

                    latestAssessments.length > 0 ?

                    latestAssessments.map(

                        (item, index) => (

                            <div

                                key={index}

                                className="assessment-item"

                            >

                                <div>

                                    <h4>

                                        {item.testName}

                                    </h4>

                                    <span>

                                        {formatDate(item.date)}

                                    </span>

                                </div>

                                <div className="assessment-score">

                                    {item.score}

                                </div>

                            </div>

                        )

                    )

                    :

                    <div className="empty-assessment">

                        No assessments completed.

                    </div>

                }

            </div>

            <button

                className="assessment-btn"

                onClick={() =>

                    setShowPopup(true)

                }

            >

                View All

                <ArrowRight size={18} />

            </button>

        </div>

        {

            showPopup &&

            (

                <div

                    className="assessment-popup-overlay"

                    onClick={() =>

                        setShowPopup(false)

                    }

                >

                    <div

                        className="assessment-popup"

                        onClick={(e) =>

                            e.stopPropagation()

                        }

                    >

                        <div className="popup-header">

                            <h3>

                                Recent Assessments

                            </h3>

                            <button

                                className="popup-close"

                                onClick={() =>

                                    setShowPopup(false)

                                }

                            >

                                <X size={22} />

                            </button>

                        </div>

                        <div className="popup-body">

                            {

                                groupedTests.map(

                                    (

                                        item,

                                        index

                                    ) => (

                                        <div

                                            key={index}

                                            className="popup-assessment-item"

                                        >

                                            <div>

                                                <h4>

                                                    {item.testName}

                                                </h4>

                                                <span>

                                                    {

                                                        item.date

                                                        ?

                                                        formatDate(

                                                            item.date

                                                        )

                                                        :

                                                        "Not Attempted"

                                                    }

                                                </span>

                                            </div>

                                            <div className="assessment-score">

                                                {item.score}

                                            </div>

                                        </div>

                                    )

                                )

                            }

                        </div>

                    </div>

                </div>

            )

        }

    </>

);
};

export default RecentAssessmentCard;